import mime from 'mime';
import fileDownload from 'js-file-download';

import commonApi from '@bo-apis/common/commonApi';

export const downloadFiles = async (fileList) => {
  if (Array.isArray(fileList)) {
    const res = await Promise.all(fileList.map(async ({ fileId }) => commonApi.downloadFile(fileId)));
    res.map(({ result: data }, idx) => {
      const { originFileNameExt, ext } = fileList.at(idx);
      fileDownload(base64toBlob(data, mime.getType(ext)), originFileNameExt);
    });
  } else {
    const file = { ...fileList };
    const { result: data } = await commonApi.downloadFile(file.fileId);
    fileDownload(base64toBlob(data, mime.getType(file.ext)), file.originFileNameExt);
  }
};

export const base64toBlob = (data, type) => {
  const bytes = atob(data);
  let { length } = bytes;
  const out = new Uint8Array(length);

  while (length--) {
    out[length] = bytes.charCodeAt(length);
  }
  return new Blob([out], { type });
};
